import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { Field } from 'react-final-form';
import { Form } from 'antd';

import { currency, schedule, workplace, worktype, grossnet } from 'constants/dictionaries';
import { SALARY_NUMBER_MASK, NATURAL_NUMBER } from 'constants/regexp';
import { formatMoney } from 'helpers/fieldsHelpers';
import { RadioButtonsLoad } from 'components/common/form/RadioButtons';
import { SelectLoadComponent } from 'components/common/form/Select';
import InputNumberMask from 'components/common/form/InputNumberMask';
import Text from 'components/common/form/Text';
import { formItemLayout } from 'constants/formItemLayout';
import { salaryNumberScan, lessThanSalaryTo, moreThanSalaryFrom, maxLength } from 'utils/validators';
import CustomIcon from 'components/common/CustomIcon';

export default class WorkConditionsForm extends Component {
    render() {
        return (
            <div className="card work-conditions-card">
                <div className="card-head">
                    <h3>
                        <CustomIcon type="laptop"/>
                        <Translate content='request.headers.workConditions'/>
                    </h3>
                </div>
                <div className='card-body'>
                    <Form.Item label={<Translate content='request.salary' />} {...formItemLayout}>
                        <Field name='salary.amount.from'
                               component={InputNumberMask}
                               placeholder='placeholders.from'
                               validate={(values, all) => salaryNumberScan(values, all) || lessThanSalaryTo(values, all)}
                               notWrap={true}
                               containerClass="inline"
                               className="amount-from"
                               step="1000"
                               mask={SALARY_NUMBER_MASK}
                               formatter={formatMoney}
                        />
                        <Field name='salary.amount.to'
                               component={InputNumberMask}
                               placeholder='placeholders.to'
                               validate={(values, all) => salaryNumberScan(values, all) || moreThanSalaryFrom(values, all)}
                               notWrap={true}
                               notError={true}
                               containerClass="inline"
                               className="amount-to"
                               step="1000"
                               mask={SALARY_NUMBER_MASK}
                               formatter={formatMoney}
                        />
                        <Field name='salary.currency'
                               component={SelectLoadComponent}
                               loadName={currency}
                               namePath='code'
                               placeholder={<Translate content='placeholders.currency' />}
                               notWrap={true}
                               containerClass="inline"
                               style={{width: '100px'}}
                               allowClear
                        />
                    </Form.Item>
                    <Form.Item wrapperCol={{ xs: formItemLayout.wrapperCol.xs, sm: { span: 16, offset: 8 }}}>
                        <Field
                            name='salary.type'
                            component={RadioButtonsLoad}
                            loadName={grossnet}
                            namePath='value'
                            label={{ content: '' }}
                            notWrap={true}
                            containerClass="inline"
                        />
                    </Form.Item>
                    <Field name='bonuses'
                           component={Text}
                           label={{ content: 'request.bonuses' }}
                           placeholder='placeholders.enterBonuses'
                           validate={maxLength(1023)}
                    />

                    <Field name='probation'
                           component={InputNumberMask}
                           mask={NATURAL_NUMBER}
                           placeholder='placeholders.specifyDays'
                           fieldClass="probation-field"
                           label={{ content: 'request.probation' }}
                           validate={maxLength(3)}
                    />

                    <Field name='workplace'
                           component={RadioButtonsLoad}
                           namePath='value'
                           loadName={workplace}
                           label={{ content: 'request.workplace' }} />

                    <Field name='schedule'
                           allowClear
                           component={SelectLoadComponent}
                           namePath='value'
                           loadName={schedule}
                           label={{ content: 'request.schedule' }}
                           placeholder={<Translate content='placeholders.chooseSchedule' />} />

                    <Field name='worktype'
                           allowClear
                           component={SelectLoadComponent}
                           namePath='value'
                           loadName={worktype}
                           label={{ content: 'request.workType' }}
                           placeholder={<Translate content='placeholders.chooseWorkType' />} />
                </div>
            </div>
        );
    }
}
